import { useContext } from 'react';

import { ProviderNavigationContext } from './ProviderNavigationContextTypes';

export const useProviderNavigation = () => {
  const context = useContext(ProviderNavigationContext);
  if (!context) {
    throw new Error('useProviderNavigation must be used within a ProviderNavigationProvider');
  }
  return context;
};
